import { isArray, asArray, isPlainObject, reflect } from './functions'
const sessionStorage = window.sessionStorage
const localStorage = window.localStorage

const autoSetObjectStorage = (objectStorage, key, value) => {
  if (objectStorage instanceof Storage) {
    objectStorage.setItem(key, value)
  } else {
    objectStorage[key] = value
  }
}

const autoGetObjectStorage = (objectStorage, key) => {
  if (objectStorage instanceof Storage) {
    return objectStorage.getItem(key)
  } else {
    return objectStorage[key]
  }
}

const autoRemoveObjectStorage = (objectStorage, key) => {
  if (objectStorage instanceof Storage) {
    objectStorage.removeItem(key)
  } else {
    delete objectStorage[key]
  }
}

export const setObject = (objectStorage, key, value) => {
  //첫번째 매개변수가 오브젝트일때
  if (isPlainObject(key)) {
    const object = key
    return Object.keys(object).reduce((dest, key) => {
      //두번째 매개변수가 함수일때
      if (typeof value === 'function') {
        const keyTransformer = value
        const transformedKey = keyTransformer(key, object[key])
        if (typeof transformedKey === 'string') {
          autoSetObjectStorage(objectStorage, transformedKey, object[key])
          dest[transformedKey] = object[key]
        }
      } else {
        autoSetObjectStorage(objectStorage, key, object[key])
        dest[key] = object[key]
      }
      return dest
    }, {})
  }
  autoSetObjectStorage(objectStorage, key, value)
}
export const getObject = (objectStorage, key) => {
  if (isArray(key)) {
    return key.reduce((dest, key) => {
      if (typeof key === 'string') {
        dest[key] = autoGetObjectStorage(objectStorage, key)
      }
      return dest
    }, {})
  }
  return autoGetObjectStorage(objectStorage, key)
}

export const removeObject = (objectStorage, key) => {
  if (typeof key === 'string') {
    autoRemoveObjectStorage(objectStorage, key)
  }

  if (isArray(key)) {
    return key.reduce((dest, key) => {
      const deletedValue = objectStorage[key]
      dest[key] = deletedValue
      autoRemoveObjectStorage(objectStorage, key)
      return dest
    }, {})
  }
}

export const setSession = (key, value) => setObject(sessionStorage, key, value)
export const getSession = (key) => getObject(sessionStorage, key)
export const removeSession = (key) => removeObject(sessionStorage, key)
export const getSessionJSON = (key) => {
  try {
    return JSON.parse(getSession(key))
  } catch (e) {
    if (sessionStorage.hasOwnProperty(key)) {
      console.error(`sessionStorage의 ${key}은 JSON 형식이 아닙니다`, e, sessionStorage[key])
      return null
    } else {
      return undefined
    }
  }
}
export const setSessionJSON = (key, value) => {
  if(value === null){
    removeSession(key)
  }
  value = reflect(value) // proxy 객체 파싱
  if (!isPlainObject(value)) {
    throw new Error(`setSessionJSON::${key}의 값은 오브젝트가 아닙니다 => `, value)
  }
  const stringJSON = JSON.stringify(value)
  setSession(key, stringJSON)
  return value
}
export const getSessionArray = (key) => asArray(getSessionJSON(key))
export const setLocal = (key, value) => setObject(localStorage, key, value)
export const getLocal = (key) => getObject(localStorage, key)
export const removeLocal = (key) => removeObject(localStorage, key)
export const getLocalJSON = (key) => {
  try {
    return JSON.parse(getLocal(key))
  } catch (e) {
    if (localStorage.hasOwnProperty(key)) {
      return null
    } else {
      return undefined
    }
  }
}
export const setLocalJSON = (key, value) => {
  if(value === null){
    removeLocal(key)
  }
  value = reflect(value) // proxy 객체 파싱
  if (!isPlainObject(value)) {
    throw new Error(`setLocalJSON::${key}의 값은 오브젝트가 아닙니다 => `, value)
  }
  const stringJSON = JSON.stringify(value)
  setLocal(key, stringJSON)
  return value
}
export const getLocalArray = (key) => asArray(getLocalJSON(key))
